import { isFeatureEnabled } from 'owa-feature-flags';

export function isOfflineBootAvailable(): boolean {
    return isFeatureEnabled('fwk-offline-boot');
}
